import { getThemeFromStorage } from 'utils/style/themeManagment';
import ThemeState from 'types/themeState';

export const themeInitialState: ThemeState = {
  mode: getThemeFromStorage(),
};
